/* Landing B2B (/pages/centros). La home tiene su reveal/FAQ en hydrup-home.js,
   que no se carga aquí: esta página lleva los suyos. */
(function(){
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => [...(r || document).querySelectorAll(s)];

  function initReveal(){
    const els = $$('.reveal');
    if(!('IntersectionObserver' in window)){ els.forEach(e => e.classList.add('in')); return; }
    const obs = new IntersectionObserver(es => es.forEach(e => {
      if(e.isIntersecting){ e.target.classList.add('in'); obs.unobserve(e.target); }
    }), { threshold: .12 });
    els.forEach(e => obs.observe(e));
  }

  function initFaq(){
    $$('.faq-q').forEach(q => q.addEventListener('click', () => {
      const item = q.parentElement, a = q.nextElementSibling, open = item.classList.contains('open');
      $$('.faq-item').forEach(it => { it.classList.remove('open'); it.querySelector('.faq-a').style.maxHeight = null; });
      if(!open){ item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
    }));
  }

  const ERRORES = {
    falta_negocio: 'Falta el nombre del centro.',
    falta_contacto: 'Déjanos al menos un teléfono o un email.',
    email_invalido: 'Revisa el email: no parece válido.',
    telefono_invalido: 'Revisa el teléfono: parece incompleto.',
  };

  const FETCH_TIMEOUT_MS = 10000;

  function datosDe(form){
    const d = Object.fromEntries(new FormData(form).entries());
    Object.keys(d).forEach(k => { if(typeof d[k] === 'string') d[k] = d[k].trim(); });
    delete d.privacidad;
    return d;
  }

  function validar(form, d){
    if(!d.contacto || !d.negocio || !d.tipo_negocio || !d.ciudad) return 'Rellena los campos marcados con *.';
    if(!d.telefono && !d.email) return ERRORES.falta_contacto;
    if(d.telefono && d.telefono.replace(/\D/g, '').length < 6) return ERRORES.telefono_invalido;
    if(d.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email)) return ERRORES.email_invalido;
    if(!form.privacidad.checked) return 'Acepta que te contactemos para poder enviarlo.';
    return null;
  }

  function mostrarOk(form, ok){
    form.hidden = true;
    if(ok) ok.hidden = false;
  }

  function mostrarErrorFallback(form){
    const err = $('.b2b-error', form); if(!err) return;
    const email = form.dataset.fallbackEmail || 'hola@drinkhydrup.com';
    err.textContent = '';
    err.appendChild(document.createTextNode('No hemos podido enviar tu solicitud. Escríbenos a '));
    const a = document.createElement('a');
    a.href = 'mailto:' + email;
    a.textContent = email;
    err.appendChild(a);
    err.appendChild(document.createTextNode(' o inténtalo de nuevo en unos minutos.'));
    err.hidden = false;
  }

  // Si el CRM no responde, el lead llega por email a la tienda con el formulario de contacto.
  // Devuelve true si Shopify confirmó el envío (redirección con contact_posted=true).
  // Ojo: Shopify rechaza este envío con "Missing CAPTCHA token" (visto el 7-oct-2026), así que
  // hoy no llega nada por aquí y quien lo intenta ve el aviso con el email de contacto.
  async function respaldo(f, d, cuerpo){
    if(!f) return false;
    f.querySelector('[name="contact[name]"]').value = d.contacto;
    f.querySelector('[name="contact[email]"]').value = d.email || 'sin-email@drinkhydrup.com';
    f.querySelector('[name="contact[phone]"]').value = d.telefono || '';
    f.querySelector('[name="contact[body]"]').value = cuerpo;
    try{
      const res = await fetch(f.action, { method: 'POST', body: new FormData(f) });
      if(res.redirected && /contact_posted=true/.test(res.url)) return true;
      if(res.ok && /contact_posted=true/.test(res.url)) return true;
      return false;
    }catch(_){
      return false;
    }
  }

  // Envía `d` al CRM; si falla, por email con `cuerpo` como texto. Pinta el resultado en el formulario.
  async function enviar(form, d, { ok, fallback, cuerpo }){
    const err = $('.b2b-error', form);
    const btn = $('button[type=submit]', form);
    err.hidden = true; btn.disabled = true;

    const irARespaldo = async () => {
      if(await respaldo(fallback, d, cuerpo)){ mostrarOk(form, ok); return; }
      mostrarErrorFallback(form);
      btn.disabled = false;
    };

    if(!form.dataset.endpoint){ await irARespaldo(); return; }

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
    try{
      const r = await fetch(form.dataset.endpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(d),
        signal: controller.signal,
      });
      clearTimeout(timeout);
      if(r.ok){ mostrarOk(form, ok); return; }
      if(r.status === 400){
        const body = await r.json().catch(() => ({}));
        err.textContent = ERRORES[body.error] || 'Revisa los datos e inténtalo de nuevo.';
        err.hidden = false; btn.disabled = false; return;
      }
      await irARespaldo();
    }catch(_){
      clearTimeout(timeout);
      await irARespaldo();
    }
  }

  function initForm(){
    const form = $('#b2bForm'); if(!form) return;
    const err = $('.b2b-error', form);
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const d = datosDe(form);
      const msg = validar(form, d);
      if(msg){ err.textContent = msg; err.hidden = false; return; }
      const tipo = (form.querySelector('select[name=tipo_negocio]').selectedOptions[0] || {}).text || d.tipo_negocio;
      await enviar(form, d, {
        ok: $('#b2bFormOk'), fallback: $('#b2bFallback'),
        cuerpo: `[B2B] ${d.negocio} · ${tipo} · ${d.ciudad}\nSocios: ${d.socios || '-'}\nReparto: ${d.reparto || '-'}\n${d.comentarios || ''}`,
      });
    });
  }

  // Landing de muestras. El CRM solo guarda como nota `comentarios`: la dirección de envío
  // y los datos de factura viajan ahí dentro; el CIF tiene además su propia columna.
  function initMuestras(){
    const form = $('#b2bSamples'); if(!form) return;
    const err = $('.b2b-error', form);
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const f = datosDe(form);
      let msg = null;
      if(!f.negocio || !f.contacto || !f.apellido || !f.telefono || !f.direccion || !f.cp || !f.ciudad) msg = 'Rellena los campos marcados con *.';
      else if(f.telefono.replace(/\D/g, '').length < 6) msg = ERRORES.telefono_invalido;
      else if(f.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email)) msg = ERRORES.email_invalido;
      else if(!form.privacidad.checked) msg = 'Acepta la política de privacidad para poder enviarlo.';
      if(msg){ err.textContent = msg; err.hidden = false; return; }
      // El CRM solo tiene `contacto`: le llega el nombre completo.
      f.contacto = `${f.contacto} ${f.apellido}`;

      const lineas = [
        'SOLICITUD DE MUESTRAS',
        `Enviar a: ${f.negocio} (a la atención de ${f.contacto})`,
        `Dirección: ${f.direccion}, ${f.cp} ${f.ciudad}`,
        f.horario && `Horario de entrega: ${f.horario}`,
        f.razon_social && `Razón social: ${f.razon_social}`,
        f.cif && `CIF: ${f.cif}`,
        f.direccion_fiscal && `Dirección fiscal: ${f.direccion_fiscal}`,
      ].filter(Boolean);
      const d = {
        negocio: f.negocio, contacto: f.contacto, telefono: f.telefono, email: f.email,
        ciudad: f.ciudad, cif: f.cif, comentarios: lineas.join('\n'), website_url: f.website_url,
      };
      await enviar(form, d, { ok: $('#b2bSamplesOk'), fallback: $('#b2bSamplesFallback'), cuerpo: '[B2B] ' + lineas.join('\n') });
    });
  }

  // Enlace de WhatsApp con el reparto de cajas ya escrito, para quien paga por transferencia o duda.
  function waUrl(texto){
    const sec = $('#b2b-caja'); if(!sec || !sec.dataset.wa) return '';
    const base = sec.dataset.waMessage || '';
    const msg = texto ? `${base}\n${texto.split(' · ').join('\n')}` : base;
    return `https://wa.me/${sec.dataset.wa}?text=${encodeURIComponent(msg)}`;
  }

  function fillReparto(texto){
    const form = $('#b2bForm');
    // Sin formulario (página solo para leads) el pedido sigue por WhatsApp.
    if(!form){ const url = waUrl(texto); if(url) window.open(url, '_blank', 'noopener'); return; }
    form.reparto.value = texto;
    const actual = form.comentarios.value.trim();
    if(!actual || actual.startsWith('Me interesa este reparto: ')) form.comentarios.value = 'Me interesa este reparto: ' + texto;
    $('#b2b-form').scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(() => form.contacto.focus({ preventScroll: true }), 500);
  }

  // Importes redondos sin decimales (81 €, 1.458 €); céntimos solo en precios por stick.
  const eur = n => {
    const redondo = n >= 100 || Math.abs(n - Math.round(n)) < 1e-9;
    return n.toLocaleString('es-ES', { style: 'currency', currency: 'EUR', useGrouping: 'always',
      minimumFractionDigits: redondo ? 0 : 2, maximumFractionDigits: redondo ? 0 : 2 });
  };
  // Totales (caja, mes, año): siempre a euros enteros.
  const eur0 = n => eur(Math.round(n));

  // Ganancia = lo que cobra por el stick menos lo que le cuesta, ambos con IVA incluido,
  // que es como lo ve el centro en la caja registradora.
  function calcularMargen({ precioCaja, sticksCaja = 30, pvp, sticksDia, dias = 30 }){
    const costeStick = precioCaja / sticksCaja;
    const margenStick = Math.max(0, pvp - costeStick);
    return { costeStick, margenStick, porCaja: margenStick * sticksCaja, alMes: margenStick * sticksDia * dias, alAno: margenStick * sticksDia * dias * 12 };
  }

  function initCalc(){
    const box = $('#b2bCalc'); if(!box) return;
    const precioCaja = parseFloat(box.dataset.boxPrice) || 21.89;
    const sticksCaja = parseInt(box.dataset.boxSticks, 10) || 30;
    const dias = parseInt(box.dataset.days, 10) || 30;
    const sticks = $('input[name=sticks]', box), pvp = $('input[name=pvp]', box);
    const out = k => $(`[data-out="${k}"]`, box);
    const pinta = () => {
      const r = calcularMargen({ precioCaja, sticksCaja, pvp: parseFloat(pvp.value), sticksDia: parseInt(sticks.value, 10), dias });
      const set = (k, v) => { const el = out(k); if(el) el.textContent = v; };
      set('sticks', sticks.value);
      set('sticks2', sticks.value);
      set('pvp', eur(parseFloat(pvp.value)));
      set('pvpLabel', eur(parseFloat(pvp.value)));
      set('coste', eur(r.costeStick));
      out('margenStick').textContent = eur(r.margenStick);
      out('porCaja').textContent = eur0(r.porCaja);
      out('alMes').textContent = eur0(r.alMes);
      out('alAno').textContent = eur0(r.alAno);
    };
    sticks.addEventListener('input', pinta); pvp.addEventListener('input', pinta); pinta();
  }

  function initCaja(){
    const sec = $('#b2b-caja'); if(!sec) return;
    const H = window.HYDRUP;
    const minimo = parseInt(sec.dataset.min, 10) || 2;
    const precioCaja = parseFloat(sec.dataset.boxPrice) || 0;
    const sticksCaja = parseInt(sec.dataset.boxSticks, 10) || 30;
    const pvp = parseFloat(sec.dataset.pvp) || 0;
    // Lo que gana el centro por stick: lo que cobra al socio menos lo que le cuesta a él.
    // Ej.: 30 sticks x 1,50 € = 45 € por caja, menos 21,89 € de coste = 23,11 € de ganancia.
    const margenStick = Math.max(0, pvp - precioCaja / sticksCaja);

    const cajas = $$('.b2b-box', sec);
    const qty = new Map(cajas.map(c => [c.dataset.flavor, 0]));
    const suma = () => [...qty.values()].reduce((a, b) => a + b, 0);
    // Cajas que el centro ya metió en el carrito: cuentan para el mínimo, o si no
    // volver a la landing para añadir más se quedaría bloqueado sin motivo.
    let yaEnCarrito = 0;
    const totalCajas = () => yaEnCarrito + suma();
    const variantesB2b = new Set(cajas.map(c => parseInt(c.dataset.variant, 10)).filter(Boolean));
    async function leerCarrito(){
      if(!variantesB2b.size) return;
      try{
        const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if(!r.ok) return;
        const cart = await r.json();
        yaEnCarrito = (cart.items || []).reduce(
          (n, it) => n + (variantesB2b.has(it.variant_id) ? it.quantity : 0), 0);
      }catch(_){ /* sin carrito legible, el mínimo se exige solo con lo elegido aquí */ }
    }
    const buy = $('[data-buy]', sec);
    const advice = $('[data-advice]', sec);
    const minMsg = $('[data-min-msg]', sec);
    const minTexto = minMsg ? minMsg.textContent : '';

    // Un sabor sin producto creado en Shopify no se puede comprar: el pedido entero
    // pasa a tramitarse por el formulario en cuanto se elige ese sabor.
    const variante = c => parseInt(c.dataset.variant, 10) || 0;
    const sinVariante = () => cajas.some(c => qty.get(c.dataset.flavor) > 0 && !variante(c));

    const reparto = () => cajas.filter(c => qty.get(c.dataset.flavor) > 0)
      .map(c => `${c.dataset.name}: ${qty.get(c.dataset.flavor)} ${qty.get(c.dataset.flavor) === 1 ? 'caja' : 'cajas'}`).join(' · ');

    const pinta = () => {
      const s = suma();
      cajas.forEach(c => {
        const q = qty.get(c.dataset.flavor);
        $('output', c).textContent = q;
        $('[data-dec]', c).disabled = q === 0;
        c.classList.toggle('on', q > 0);
      });
      $('[data-count]', sec).textContent = s;
      const lbl = $('[data-count-label]', sec); if(lbl) lbl.textContent = s === 1 ? 'caja' : 'cajas';
      const sticks = s * sticksCaja;
      const st = $('[data-sticks]', sec); if(st) st.textContent = sticks;
      const total = $('[data-total-price]', sec);
      if(total) total.textContent = s ? eur(s * precioCaja) : '—';
      const venta = $('[data-sale]', sec);
      if(venta) venta.textContent = s ? eur0(sticks * pvp) : '—';
      const gain = $('[data-gain]', sec);
      if(gain) gain.textContent = s ? '+' + eur0(sticks * margenStick) : '—';
      const sh = $('[data-sale-hint]', sec);
      if(sh && s) sh.textContent = sticks + ' sticks a ' + eur(pvp);
      const t = totalCajas();
      const faltan = minimo - t;
      if(minMsg){
        if(faltan > 0 && s > 0) minMsg.textContent = `Te falta${faltan === 1 ? '' : 'n'} ${faltan} caja${faltan === 1 ? '' : 's'} para llegar al mínimo.`;
        else if(yaEnCarrito) minMsg.textContent = `Ya llevas ${yaEnCarrito} caja${yaEnCarrito === 1 ? '' : 's'} en el carrito.`;
        else minMsg.textContent = minTexto;
      }
      if(advice && advice.tagName === 'A') advice.href = waUrl(reparto());
      buy.textContent = sinVariante() ? 'Solicitar pedido' : sec.dataset.btnBuy || buy.textContent;
      buy.disabled = s === 0 || t < minimo;
    };

    cajas.forEach(c => {
      const id = c.dataset.flavor;
      $('[data-inc]', c).addEventListener('click', () => { qty.set(id, qty.get(id) + 1); pinta(); });
      $('[data-dec]', c).addEventListener('click', () => { qty.set(id, Math.max(0, qty.get(id) - 1)); pinta(); });
    });

    buy.addEventListener('click', async () => {
      if(!suma() || totalCajas() < minimo) return;
      // Sin producto creado, o Shopify rechazó el intento anterior: se tramita por el formulario.
      if(buy.dataset.fallback === '1' || sinVariante()){ window.HYDRUP_B2B.fillReparto(reparto()); return; }
      buy.disabled = true; // evita doble click mientras la petición está en curso
      let ok = true;
      for(const c of cajas){
        const q = qty.get(c.dataset.flavor); if(!q) continue;
        const r = (H && H.addLine) ? await H.addLine(variante(c), q, { _b2b: '1' }) : false;
        if(!r){ ok = false; break; }
      }
      if(ok){ qty.forEach((_, k) => qty.set(k, 0)); await leerCarrito(); }
      pinta(); // restaura el estado normal (habilitado sólo si se mantiene el mínimo)
      if(ok) return;
      // Shopify rechazó el pedido (p.ej. sin stock; el toast ya muestra el motivo):
      // nos quedamos en la página y pasamos a modo asesoramiento para el próximo click.
      buy.textContent = 'Solicitar pedido';
      buy.dataset.fallback = '1';
    });
    // Si es un enlace de WhatsApp, su href ya lleva el reparto: se deja abrir solo.
    if(advice && advice.tagName !== 'A') advice.addEventListener('click', () => window.HYDRUP_B2B.fillReparto(reparto() || 'Aún sin decidir'));
    // Bajo el precio de la caja: lo que sale el stick y desde cuántas cajas aplica.
    const coletilla = sec.dataset.unitNote ? ' · ' + sec.dataset.unitNote : '';
    cajas.forEach(c => {
      const u = $('[data-unit-price]', c);
      if(u) u.textContent = eur(precioCaja / sticksCaja) + ' por stick' + coletilla;
    });
    sec.dataset.btnBuy = buy.textContent;
    pinta();
    leerCarrito().then(pinta);
  }

  window.HYDRUP_B2B = Object.assign(window.HYDRUP_B2B || {}, { fillReparto });
  document.addEventListener('DOMContentLoaded', () => { initReveal(); initFaq(); initForm(); initMuestras(); initCalc(); initCaja(); });
})();
